import React from "react";
import { Link } from "react-router-dom";

const AdminNavigation = () => {
    return (
        <div className="side-navigation">
            <ul>
                <li>
                    <Link to="/admin">Dashboard Control</Link>
                </li>
                <li>
                    <Link to="/admin/filters">Filters</Link>
                </li>
                <li>
                    <Link to="/admin/dictionary">Dictionary</Link>
                </li>
                <li>
                    <Link to="/admin/notify">Notify</Link>
                </li>
                <li>
                    <Link to="/admin/notifications">Notifications</Link>
                </li>
                <li>
                    <Link to="/admin/projectsnapshots">Project Snapshots</Link>
                </li>
                <li>
                    <Link to="/admin/comments">Comments</Link>
                </li>
                <li>
                    <Link to="/admin/flags">Flags</Link>
                </li>
                <li>
                    <Link to="/admin/impersonate">Impersonate</Link>
                </li>
                <li>
                    <Link to="/admin/reset">Reset</Link>
                </li>
                <li>
                    <Link to="/admin/canary/config">Canary Config</Link>
                </li>
                <li>
                    <Link to="/admin/canary/validation">Canary Validation</Link>
                </li>
                <li>
                    <Link to="/admin/feature-flags">Feature Flags</Link>
                </li>
            </ul>
        </div>
    );
};

export default AdminNavigation;
